import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=76ab4858&scoped=true"
import script from "./Distribution.vue?vue&type=script&lang=js"
export * from "./Distribution.vue?vue&type=script&lang=js"
import style0 from "./Distribution.vue?vue&type=style&index=0&id=76ab4858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ab4858",
  null
  
)

export default component.exports